import { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Download, ExternalLink, FileText, ImageIcon } from "lucide-react";
import { getApiUrl } from "@/lib/api";

const API = getApiUrl();

export default function LunchMenuSection() {
  const [menuInfo, setMenuInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/weekly-menu`)
      .then((res) => {
        if (res.data && res.data.filename) {
          setMenuInfo(res.data);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const fileUrl = menuInfo ? `${API}/weekly-menu/file/${menuInfo.filename}` : null;
  const isImage = menuInfo?.file_type?.startsWith("image/");
  const isPdf = menuInfo?.file_type === "application/pdf";

  return (
    <section id="lunch-menu" data-testid="lunch-menu-section" className="py-20 md:py-32 bg-[#051F16]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 reveal reveal-up">
          <p className="text-xs uppercase tracking-[0.3em] text-[#EAB308] mb-4">
            Týdně aktualizováno
          </p>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-5xl font-semibold text-[#F0FDF4] tracking-tight">
            Polední menu
          </h2>
          <p className="text-[#94A3B8] mt-4 text-sm">
            Nabídku obědového menu aktualizujeme každé pondělí
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <div className="w-8 h-8 border-2 border-[#EAB308] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : !menuInfo ? (
          <div className="text-center py-16 border border-[#1D4133] rounded-sm bg-[#02120D]/50">
            <FileText className="w-12 h-12 text-[#94A3B8] mx-auto mb-4" />
            <p className="text-[#94A3B8]">Týdenní menu bude brzy nahráno</p>
            <p className="text-xs text-[#94A3B8]/60 mt-2">Sledujte nás pro aktuální nabídku</p>
          </div>
        ) : (
          <div className="space-y-6">
            {/* Preview */}
            <div className="border border-[#1D4133] rounded-sm overflow-hidden bg-[#02120D]/50">
              {isImage && (
                <img
                  src={fileUrl}
                  alt="Týdenní menu"
                  className="w-full max-h-[600px] object-contain"
                  data-testid="weekly-menu-image"
                />
              )}
              {isPdf && (
                <div className="w-full" data-testid="weekly-menu-pdf">
                  <iframe
                    src={fileUrl}
                    title="Týdenní menu"
                    className="w-full h-[500px] md:h-[700px]"
                    style={{ border: "none" }}
                  />
                </div>
              )}
            </div>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                <Button
                  data-testid="open-menu-new-tab"
                  className="bg-[#EAB308] text-[#02120D] hover:bg-yellow-500 rounded-sm font-semibold uppercase tracking-wider px-6 py-2.5 text-sm"
                >
                  <ExternalLink className="w-4 h-4 mr-2" />
                  Otevřít v novém okně
                </Button>
              </a>
              <a href={fileUrl} download>
                <Button
                  variant="outline"
                  data-testid="download-menu-btn"
                  className="border-[#1D4133] text-[#E2E8F0] hover:bg-[#0B2A20] rounded-sm uppercase tracking-wider px-6 py-2.5 text-sm"
                >
                  <Download className="w-4 h-4 mr-2" />
                  Stáhnout
                </Button>
              </a>
            </div>

            {menuInfo.upload_date && (
              <p className="text-center text-xs text-[#94A3B8]/60">
                Nahráno: {new Date(menuInfo.upload_date).toLocaleDateString("cs-CZ")}
              </p>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
